import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import useClipboard from 'react-use-clipboard';
import QRCode from 'qrcode.react';

import Button from '../../../../../../components/global/Button';
import Angle from '../../../../../../components/global/Angle';
import QRIcon from '../../../../../../components/icons/QRIcon';
import LinkIcon from '../../../../../../components/icons/LinkIcon';

const propTypes = {
  account: PropTypes.shape({
    username: PropTypes.string,
  }).isRequired,
  shareUrl: PropTypes.string.isRequired,
};

const STEPS = {
  SHARE: 'SHARE',
  QR: 'QR',
};

const AccountShare = ({ account, shareUrl }) => {
  const [step, setStep] = useState(STEPS.SHARE);
  const [copied, setCopied] = useClipboard(shareUrl);

  const onQRCodeDownload = () => {
    const canvas = document.getElementById(`${account?.id}-qr`);
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${account?.username}-QR.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Fragment>
      {step === STEPS.SHARE && (
        <Fragment>
          <h3 className="text-center mt-0">
            Share <span className="text-primary">@{account?.username}</span>
            &apos;s profile
          </h3>
          <p className="text-sm text-light">Anyone with the link can access</p>
          <div className="d-flex">
            <Button
              onClick={setCopied}
              btnStyle="reset"
              className="account-share-action-button mr-1"
            >
              <div>
                <LinkIcon color="#0d84fe" size={20} />
              </div>
              {copied ? 'Copied!' : 'Copy'}
            </Button>
            <Button
              onClick={() => setStep(STEPS.QR)}
              btnStyle="reset"
              className="account-share-action-button"
            >
              <div>
                <QRIcon color="#0d84fe" size={20} />
              </div>
              QR
            </Button>
          </div>
        </Fragment>
      )}
      {step === STEPS.QR && (
        <Fragment>
          <Button
            onClick={() => setStep(STEPS.SHARE)}
            btnStyle="link"
            className="mb-2 text-bold"
          >
            <Angle direction="left" className="mr-1" /> Back
          </Button>
          <div className="d-flex flex-column align-items-center">
            <h3 className="mb-4">Share QR Code</h3>
            <QRCode
              id={`${account?.id}-qr`}
              value={shareUrl}
              renderAs="canvas"
              size={200}
              className="mb-4"
            />
            <Button onClick={onQRCodeDownload}>Download PNG</Button>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

AccountShare.propTypes = propTypes;

export default AccountShare;
